"use strict";

var hyperscript = require('hyperscript');

var objectAssign = require('object-assign');

var getImageUrl = require('./getImageUrl');

var blocksToNodes = require('./blocksToNodes');

var getSerializers = require('./serializers');

var renderNode = function renderNode(serializer, properties, children) {
  var props = properties || {};

  if (typeof serializer === 'function') {
    return serializer(objectAssign({}, props, {
      children: children
    }));
  }

  var tag = serializer;
  var childNodes = props.children || children;
  return hyperscript(tag, props, childNodes);
};

var _getSerializers = getSerializers(renderNode, {
  useDashedStyles: true
}),
    defaultSerializers = _getSerializers.defaultSerializers,
    serializeSpan = _getSerializers.serializeSpan;

var blockContentToHyperscript = function blockContentToHyperscript(options) {
  return blocksToNodes(renderNode, options, defaultSerializers, serializeSpan);
}; // Expose default serializers to the user


blockContentToHyperscript.defaultSerializers = defaultSerializers; // Expose logic for building image URLs from an image reference/node

blockContentToHyperscript.getImageUrl = getImageUrl; // Expose node renderer

blockContentToHyperscript.renderNode = renderNode;
module.exports = blockContentToHyperscript;
//# sourceMappingURL=index.js.map